/* eslint-disable prettier/prettier */
const HOST = process.env.REACT_APP_API_BASE_URL;
const HOST1 = process.env.REACT_APP_SECONDARY_API_BASE_URL;
export const SERVICES = {
  CONTRIBUTION_LOGIN: `${HOST}/contributionLogin`,
  OTP_AUTHENTICATION: `${HOST}/mfa`,
  GET_MEMBER_DETAILS: `${HOST1}/contribution/api/members`,
  GET_PROFILE: `${HOST}/api/profile`,
  GET_MEMBER: `${HOST}/api/members`,
  // GET_MEMBER_SEARCH: `${HOST}/api/reports/members`,
  GET_MEMBER_SEARCH: `${HOST1}/contribution/api/members/search`,
  PAYABLE_CITY: `${HOST1}/contribution/api/payableCities`,
  BANKS_DETAILS: `${HOST1}/contribution/api/banks`,
  GET_BSG_BANKS: `${HOST1}/contribution/api/banks/master`,
  OFFLINE_BANK_DEPOSIT: `${HOST1}/contribution/api/offlineBankDeposit`,
  RECEIPT_TYPES: `${HOST1}/contribution/api/receiptTypes`,
  CONTRIBUTION_CYCLE: `${HOST1}/contribution/api/contributionCycles`,
  CHAPTER_CONTRIBUTION_CYCLE: `${HOST1}/contribution/api/chapterContributionCycle`,
  GET_MONTHLY_CONTRIBUTION: `${HOST1}/contribution/api/drilldown`,
  GET_PAYMENT_TYPE: `${HOST1}/contribution/api/paymentType/drilldown`,
  GET_DIVISION_TYPE: `${HOST1}/contribution/api/division/drilldown`,
  AGGREGATED_CONTRIBUTION: `${HOST1}/contribution/api/aggregation`,
  GET_PAYMENT_GATEWAY: `${HOST1}/contribution/api/paymentGateway`,
  GET_TOTAL_RECEIPT_REPORTS: `${HOST1}/contribution/api/reports/totalReceipt`,
  GET_TOTAL_CANCELLED_RECEIPT_REPORTS: `${HOST1}/contribution/api/reports/totalCancelledReceipt`,
  GET_CANCELLED_RECEIPT_REPORTS: `${HOST1}/contribution/api/orders/cancelled-transactions`,
  GET_CAPTURED_REPORT: `${HOST1}/contribution/api/reports/capturedReport`,
  GET_TOTAL_COLLECTION_REPORTS: `${HOST1}/contribution/api/reports/collection`,
  GET_CHAPTER_COLLECTION_REPORTS: `${HOST1}/contribution/api/reports/chapterCollection`,
  GET_CONTRIBUTION_COMPARISON_REPORTS: `${HOST1}/contribution/api/reports/comparison`,
  UIN_TYPES: `${HOST1}/contribution/api/masters/uinTypes`,
  PAYMENT_METHODS: `${HOST1}/contribution/api/masters/paymentMethods`,
  GET_CONTRIBUTION_CYCLE: `${HOST1}/contribution/api/masters/contributionCycles`,
  GET_LIST_CHEQUES_DD_REPORTS: `${HOST1}/contribution/api/reports/cheques`,
  DOWNLOAD_TOTAL_RECEIPT_REPORTS: `${HOST1}/contribution/api/reports/download/totalReceipts`,
  DOWNLOAD_TOTALCANCELLED_RECEIPT_REPORTS: `${HOST1}/contribution/api/reports/download/cancelledTotalReceipts`,
  DOWNLOAD_CAPTURE_ONLINE_REPORTS: `${HOST1}/contribution/api/reports/download/capturedReports`,
  DOWNLOAD_TOTAL_COLLECTION_REPORTS: `${HOST1}/contribution/api/reports/download/totalCollection`,
  DOWNLOAD_CHAPTER_COLLECTION_REPORTS: `${HOST1}/contribution/api/reports/download/totalChapterCollection`,
  DOWNLOAD_CHEQUES_DD_REPORTS: `${HOST1}/contribution/api/reports/download/chequeReports`,
  DOWNLOAD_CHEQUES_BANK_DEPOSIT_SLIP: `${HOST1}/contribution/api/reports/download/cheque-bank-deposit-slip`,
  DOWNLOAD_CHAPTER_CHEQUES_BANK_DEPOSIT_SLIP: `${HOST1}/contribution/api/reports/download/chapter-cheque-bank-deposit-slip`,
  DOWNLOAD_CHAPTER_CASH_BANK_DEPOSIT_SLIP: `${HOST1}/contribution/api/reports/download/chapter-cash-bank-deposit-slip`,
  GET_DOWNLOAD_REPORTS: `${HOST1}/contribution/api/tasks`,
  CAPTURE_VERIFY: `${HOST1}/contribution/api/contributions/capture/paymentOrders`,
  PAYMENT_ORDER_MARK_STATUS: `${HOST1}/contribution/api/contributions/capture/paymentOrders/markStatus`,
  DOWNLOAD_BANK_DEPOSIT_SLIP: `${HOST1}/contribution/api/reports/download/bank-deposit-slip`,
  CREATE_CHAPTER_LEVEL_CONTRIBUTION_CYCLE: `${HOST1}/contribution/api/chapterContributionCycle`,
  PROCESS_PDFS_FILE: `${HOST1}/contribution/api/reports/process-pdfs`,
  GET_S3_URL: `${HOST1}/contribution/api/upload/signed-url`,
  GENERATE_CSV: `${HOST1}/contribution/api/reports/generate-it-form-csv`,
  FORM10BE_SEARCH: `${HOST1}/contribution/api/members/form10BE/search`,
  SEND_EMAIL: `${HOST1}/contribution/api/reports/sendEmail`,
  AREA: `${HOST}/api/structures/areas`,
  CLUSTER: `${HOST}/api/structures/cluster`,
  ZONE: `${HOST}/api/structures/zones`,
  REGION: `${HOST}/api/structures/regions`,
  CHAPTER: `${HOST}/api/structures/chapters`,
  DISTRICT: `${HOST}/api/structures/districts`,
  BLOCK: `${HOST}/api/structures/blocks`,
};
